import {
  ShippingClaimSchema,
  shippingClaimUpdateSchema,
} from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";
import * as z from "zod";

export const updateShippingClaim = {
  name: "updateShippingClaim" as const,
  input: shippingClaimUpdateSchema,
  output: z.object({ shippingClaim: ShippingClaimSchema }),
};
